import { v4 } from "uuid";

import { ReactComponent as HomeIcon } from "assets/svg/home.svg";
import { ReactComponent as ApplicationsIcon } from "assets/svg/applications.svg";
// import { ReactComponent as SubscriptionsIcon } from "assets/svg/subscriptions.svg";
import { ReactComponent as EmployeeIcon } from "assets/svg/employee.svg";
import { ReactComponent as PaymentIcon } from "assets/svg/payment.svg";
import { ReactComponent as CouponIcon } from "assets/svg/coupon.svg";
import { ReactComponent as SettingsIcon } from "assets/svg/settings.svg";
import { ReactComponent as VerifyIcon } from "assets/svg/verification.svg";
import { ReactComponent as TaxIcon } from "assets/svg/receipt.svg";
// import { ReactComponent as WebhookIcon } from "assets/svg/binocular.svg";
// import { ReactComponent as StoreIcon } from "assets/svg/store.svg";

export const sidebarData = [
    {
        id: v4(),
        to: "/",
        text: "dashboard",
        svg: <HomeIcon />,
    },

    {
        id: v4(),
        to: "/applications",
        text: "applications",
        svg: <ApplicationsIcon />,
        // children: [
        //   {
        //     id: v4(),
        //     to: "/applications",
        //     text: "allApplications",
        //   },
        // ],
    },

    // {
    //   id: v4(),
    //   to: "/themes",
    //   text: "themes",
    //   svg: <ThemesIcon />,
    // },

    // {
    //   id: v4(),
    //   to: "/subscriptions",
    //   text: "subscriptions",
    //   svg: <SubscriptionsIcon />,
    // },
    // {
    //   id: v4(),
    //   to: "/demoStores",
    //   text: "demoStores",
    //   svg: <StoreIcon />,
    // },
    {
        id: v4(),
        to: "/employees",
        text: "employees",
        svg: <EmployeeIcon />,
    },
    {
        id: v4(),
        to: "/payments",
        text: "payments",
        svg: <PaymentIcon />,
    },
    {
        id: v4(),
        to: "/coupons",
        text: "coupons",
        svg: <CouponIcon />,
    },
    {
        id: v4(),
        to: "/settings",
        text: "settings",
        svg: <SettingsIcon />,
    },
    // {
    //   id: v4(),
    //   to: "/webhooks",
    //   text: "webhooks",
    //   svg: <WebhookIcon />,
    // },
];

//settings page cards
export const settingsData = [
    {
        id: v4(),
        to: "/settings/identityVerification",
        text: "identityVerification",
        svg: <VerifyIcon />,
    },

    // {
    //   id: v4(),
    //   to: "/communications",
    //   text: "communications",
    //   svg: <LinkIcon />,
    // },

    {
        id: v4(),
        to: "/settings/payment-methods",
        text: "paymentMethods",
        svg: <PaymentIcon />,
    },
    {
        id: v4(),
        to: "/settings/taxNumber",
        text: "taxNumber",
        svg: <TaxIcon />,
    },
];

export const permissions = [
    "revisions",
    "mainData",
    "clients",
    "orders",
    "carts",
    "branches",
    "sections",
    "brands",
    "products",
    "webhooks",
    "payments",
    "taxes",
    "specialOffers",
    "countries",
    "delivery",
    "marketing",
    "descriptive",
];

export const appEvents = [
    {
        label: "permissionGrant",
        link: "#",
    },
    {
        label: "download",
        link: "#",
    },
    {
        label: "update",
        link: "#",
    },
    {
        label: "delete",
        link: "#",
    },
    {
        label: "betaStart",
        link: "#",
    },
    {
        label: "betaEnd",
        link: "#",
    },
];

export const storeEvents = [
    {
        name: "orders",
        options: [
            "ordersCreate",
            "ordersDetailsUpdate",
            "ordersDelete",
            "ordersStatusUpdate",
            "ordersRefund",
            "ordersCancel",
        ],
    },
    {
        name: "products",
        options: [
            "productsCreate",
            "productsDataUpdate",
            "productsDelete",
            "productsAvailable",
            "productsQuantityLow",
        ],
    },
    {
        name: "clients",
        options: ["login", "otpRequest", "profileUpdate", "register"],
    },
    { name: "categories", options: ["categoriesCreate", "categoriesUpdate"] },
    {
        name: "brands",
        options: ["brandsCreate", "brandsUpdate", "brandsDelete"],
    },
    {
        name: "branches",
        options: [
            "branchesDelete",
            "branchesCreate",
            "branchesUpdate",
            "branchesSetDefault",
            "branchesDisable",
            "branchesTaxes",
        ],
    },
    {
        name: "uncategorized",
        options: [
            "copounUse",
            "addRate",
            "leftCartCreate",
            "newOfferAdd",
            "newOfferUpdate",
        ],
    },
    {
        name: "delivery",
        options: [
            "areaAdd",
            "areaUpdate",
            "deliveryAdd",
            "deliveryUpdate",
            "deliveryDelete",
        ],
    },
];
